<script>
  import Rocket from "../../assets/svgs/rocket.svg";

  const width = "60%";
</script>

<div class="rocket-container">
  <Rocket width="{width}" />
</div>
